<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn v-if="person.is_supervisor == 1" @click="openChangePin()" color="primary">{{
                                person.has_pin == 1 ? "Change Pin" : "Set Pin"
                            }}</v-btn>
                            <v-btn @click="openChangePassword()" color="primary" class="hidden-sm-and-down">
                                {{ $t("lang.change_password") }}
                            </v-btn>
                            <bc-btn-refresh @invoke-method="dbGetMe()"></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobileList"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-container fluid grid-list-xl>
                    <v-layout row wrap>
                        <v-flex xs12 px-2 pb-0 :class="{ 'd-none': !$bp.smallScreen }">
                            <bc-list v-if="entity_phones" :items="entity_phones" prepend-icon="phone" @invoke-method="showEntity($event, 'phone')">
                                <template slot-scope="data">
                                    <v-flex>{{ data.item.phone_number_formatted ? data.item.phone_number_formatted : data.item.phone_number }}</v-flex>
                                    <v-flex list-sub>{{ $t(`lang.${data.item.phone_type}`) }}</v-flex>
                                </template>
                            </bc-list>
                            <v-divider v-if="entity_emails" class="my-0"></v-divider>
                            <bc-list v-if="entity_emails" :items="entity_emails" prepend-icon="email" @invoke-method="showEntity($event, 'email')">
                                <template slot-scope="data">
                                    <v-flex>{{ data.item.email_address }}</v-flex>
                                    <v-flex list-sub>{{ $t(`lang.${data.item.email_type}`) }}</v-flex>
                                </template>
                            </bc-list>
                            <v-divider v-if="entity_addresses" class="my-0"></v-divider>
                            <bc-list
                                v-if="entity_addresses"
                                :items="entity_addresses"
                                prepend-icon="location_on"
                                @invoke-method="showEntity($event, 'address')"
                            >
                                <template slot-scope="data">
                                    <v-flex>{{ data.item.address1 }}</v-flex>
                                    <v-flex list-sub>{{ `${data.item.city}, ${data.item.state} ${data.item.zip_code}` }}</v-flex>
                                    <v-flex list-sub>{{ $t(`lang.${data.item.address_type}`) }}</v-flex>
                                </template>
                            </bc-list>
                        </v-flex>
                        <v-flex xs12 md3 class="my-profile">
                            <v-card-text class="px-0">
                                <v-form ref="my_profile">
                                    <v-container class="px-0 grid-list-form">
                                        <v-layout row wrap>
                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    v-focus="!$bp.smallScreen"
                                                    v-model="my_profile.first_name"
                                                    :label="`${$t('lang.first_name')} *`"
                                                    :counter="showCounter(my_profile.first_name, 'person.first_name')"
                                                    :rules="ifValid('person.first_name')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    v-model="my_profile.last_name"
                                                    :label="`${$t('lang.last_name')} *`"
                                                    :counter="showCounter(my_profile.last_name, 'person.last_name')"
                                                    :rules="ifValid('person.last_name')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    v-model="my_profile.nick_name"
                                                    :label="$t('lang.nick_name')"
                                                    :counter="showCounter(my_profile.nick_name, 'person.nick_name')"
                                                    :rules="ifValid('person.nick_name')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    v-model="my_profile.job_title"
                                                    :label="`${$t('lang.job_title')} *`"
                                                    :counter="showCounter(my_profile.job_title, 'person.job_title')"
                                                    :rules="ifValid('person.job_title')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <bc-select
                                                    v-model="my_profile.unit_of_measure"
                                                    :label="`${$t('lang.unit_of_measure')} *`"
                                                    :items="unit_of_measure"
                                                    item-value="value"
                                                    item-text="text"
                                                    :rules="ifValid('person.unit_of_measure')"
                                                ></bc-select>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <bc-autocomplete
                                                    v-model="my_profile.language"
                                                    :label="`${$t('lang.language')} *`"
                                                    :items="active_languages"
                                                    item-value="iso"
                                                    item-text="language"
                                                    :rules="ifValid('person.language')"
                                                ></bc-autocomplete>
                                            </v-flex>
                                            <v-flex xs12>
                                                <bc-autocomplete
                                                    v-model="my_profile.user_time_zone"
                                                    :label="$t('lang.user_time_zone')"
                                                    :items="time_zones"
                                                    item-value="value"
                                                    item-text="text"
                                                    :rules="ifValid('person.user_time_zone')"
                                                >
                                                    <template slot="item" slot-scope="data">
                                                        {{ data.item.text }}
                                                    </template>
                                                </bc-autocomplete>
                                            </v-flex>
                                            <v-flex xs12>
                                                <bc-autocomplete
                                                    v-model="my_profile.entity_phones_id"
                                                    :label="$t('lang.mobile_phone_notification')"
                                                    :items="entity_phones ? entity_phones : []"
                                                    item-value="entity_phones_id"
                                                    item-text="phone_number"
                                                    clearable
                                                    @click:clear="
                                                        $nextTick(() => {
                                                            my_profile.entity_phones_id = '';
                                                        })
                                                    "
                                                >
                                                    <template slot="item" slot-scope="data">
                                                        {{ data.item.phone_number_formatted ? data.item.phone_number_formatted : data.item.phone_number }}
                                                    </template>
                                                    <template slot="selection" slot-scope="data">
                                                        {{ data.item.phone_number_formatted ? data.item.phone_number_formatted : data.item.phone_number }}
                                                    </template>
                                                </bc-autocomplete>
                                            </v-flex>
                                            <v-flex xs12>
                                                <bc-autocomplete
                                                    v-model="my_profile.entity_emails_id"
                                                    :label="$t('lang.email_address_notification')"
                                                    :items="entity_emails ? entity_emails : []"
                                                    item-value="entity_emails_id"
                                                    item-text="email_address"
                                                    clearable
                                                    @click:clear="
                                                        $nextTick(() => {
                                                            my_profile.entity_emails_id = '';
                                                        })
                                                    "
                                                ></bc-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 mt-3>
                                                <v-btn class="ml-auto" color="success" @click="edit()">
                                                    {{ $t("lang.save") }}
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                        </v-flex>
                        <v-flex xs12 md9 :class="{ 'd-none': $bp.smallScreen }">
                            <v-expansion-panel style="align-self: flex-start" v-model="panel" :expand="true">
                                <v-expansion-panel-content>
                                    <template slot="header">
                                        <div class="title">
                                            {{ $t("lang.userPhones") }} - {{ entity_phones && entity_phones.length > 0 ? entity_phones.length : "None" }}
                                        </div>
                                    </template>
                                    <my-phones ref="myPhones" :getFunction="getPhones" :phones="entity_phones || []"></my-phones>
                                </v-expansion-panel-content>
                                <v-expansion-panel-content>
                                    <template slot="header">
                                        <div class="title">
                                            {{ $t("lang.userEmails") }} - {{ entity_emails && entity_emails.length > 0 ? entity_emails.length : "None" }}
                                        </div>
                                    </template>
                                    <my-emails ref="myEmails" :getFunction="getEmails" :emails="entity_emails || []"></my-emails>
                                </v-expansion-panel-content>
                                <v-expansion-panel-content>
                                    <template slot="header">
                                        <div class="title">
                                            {{ $t("lang.userAddresses") }} -
                                            {{ entity_addresses && entity_addresses.length > 0 ? entity_addresses.length : "None" }}
                                        </div>
                                    </template>
                                    <my-addresses ref="myAddresses" :getFunction="getAddresses" :addresses="entity_addresses || []"></my-addresses>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>

            <bc-dialog :value="update_password_dialog">
                <v-card>
                    <v-card-title class="red-dialog-title">
                        <span class="headline">{{ $t("lang.change_password") }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="update_password_dialog"
                            :dialog-status="update_password_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="update_password">
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <bc-password-input
                                            :focus="update_password_dialog"
                                            v-model="update_password.current_password"
                                            :label="`${$t('lang.current_password')} *`"
                                            :rules="ifValid('update_password.current_password')"
                                        ></bc-password-input>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-password-input
                                            v-model="update_password.password"
                                            :label="`${$t('lang.password')} *`"
                                            :counter="showCounter(update_password.password, 'update_password.password')"
                                            :rules="ifValid('update_password.password')"
                                        ></bc-password-input>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-password-input
                                            v-model="confirm_password"
                                            :label="`${$t('lang.confirm_password')} *`"
                                            :counter="showCounter(confirm_password, 'update_password.confirm_password')"
                                            :rules="ifValid('update_password.confirm_password')"
                                        ></bc-password-input>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="update_password_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @mouseup.left="changePassword()">{{ $t("lang.update") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
        </v-container>
        <bc-modal-supervisor-pin ref="modalSupervisorPin" @eventname=""></bc-modal-supervisor-pin>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";

import MyAddresses from "Core/users/views/UserMyAddresses";
import MyPhones from "Core/users/views/UserMyPhones";
import MyEmails from "Core/users/views/UserMyEmails";
import { store } from "Store/store";

export default {
    components: {
        MyAddresses,
        MyPhones,
        MyEmails,
    },
    data() {
        return {
            my_profile: {
                first_name: "",
                last_name: "",
                nick_name: "",
                job_title: "",
                unit_of_measure: "",
                user_time_zone: "",
                theme: "",
                language: "",
                entity_phones_id: "",
                entity_emails_id: "",
            },
            update_password: {
                current_password: "",
                password: "",
            },
            confirm_password: "",
            time_zones: [],
            update_password_dialog: false,
            mobileList: [
                { title: this.$t("lang.addNumber"), action: "showPhone", ref: "myPhones" },
                { title: this.$t("lang.addEmail"), action: "showEmail", ref: "myEmails" },
                { title: this.$t("lang.addAddress"), action: "showAddress", ref: "myAddresses" },
                { title: this.$t("lang.change_password"), action: "openChangePassword" },
                { title: this.$t("lang.refresh"), action: "dbGetMe" },
            ],
            panel: [true, true, true],
            dbGetMe: _.debounce(this.getMe, 1500, { maxWait: 1500, leading: true, trailing: false }),
            unit_of_measure: [
                { value: "0", text: "Imperial" },
                { value: "1", text: "Metric" },
            ],
        };
    },
    beforeRouteEnter(to, from, next) {
        const person = new Promise((resolve, reject) => {
            store
                .dispatch("fetchMe", {
                    url: "me",
                    method: "get",
                    stateProperty: "person|entity_phones|entity_addresses|entity_emails",
                    dataProperty: "person|person.entity_phones|person.entity_addresses|person.entity_emails",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.person) : reject(new Error("reject"));
                });
        });

        const time_zones = new Promise((resolve, reject) => {
            store
                .dispatch("fetchTimeZones", {
                    url: "timezones",
                    method: "get",
                    stateProperty: "time_zones",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.time_zones) : reject(new Error("reject"));
                });
        });

        const languages = new Promise((resolve, reject) => {
            store
                .dispatch("fetchLanguages", {
                    url: "languages?status=1",
                    method: "get",
                    stateProperty: "active_languages",
                    dataProperty: "languages",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.languages) : reject(new Error("reject"));
                });
        });

        Promise.all([person, time_zones, languages])
            .then(([person, time_zones, languages]) => {
                next((vm) => {
                    //person data
                    vm.my_profile = {
                        first_name: person.first_name,
                        last_name: person.last_name,
                        nick_name: person.nick_name,
                        job_title: person.job_title,
                        unit_of_measure: person.unit_of_measure,
                        user_time_zone: person.user_time_zone,
                        theme: person.theme,
                        language: person.language,
                        entity_phones_id: person.entity_phones_id,
                        entity_emails_id: person.entity_emails_id,
                    };
                    //time_zones
                    vm.time_zones = time_zones;

                    vm.finishLoader();
                });
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    beforeRouteUpdate(to, from, next) {
        const person = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchMe", {
                    url: "me",
                    method: "get",
                    stateProperty: "person|entity_phones|entity_addresses|entity_emails",
                    dataProperty: "person|person.entity_phones|person.entity_addresses|person.entity_emails",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.person) : reject(new Error("reject"));
                });
        });

        const time_zones = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchTimeZones", {
                    url: "timezones",
                    method: "get",
                    stateProperty: "time_zones",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.time_zones) : reject(new Error("reject"));
                });
        });

        const languages = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchLanguages", {
                    url: "languages?status=1",
                    method: "get",
                    stateProperty: "active_languages",
                    dataProperty: "languages",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" ? resolve(data.languages) : reject(new Error("reject"));
                });
        });

        Promise.all([person, time_zones, languages])
            .then(([person, time_zones, languages]) => {
                //person data
                this.my_profile = {
                    first_name: person.first_name,
                    last_name: person.last_name,
                    nick_name: person.nick_name,
                    job_title: person.job_title,
                    unit_of_measure: person.unit_of_measure,
                    user_time_zone: person.user_time_zone,
                    theme: person.theme,
                    language: person.language,
                    entity_phones_id: person.entity_phones_id,
                    entity_emails_id: person.entity_emails_id,
                };

                //time_zones
                this.time_zones = time_zones;

                this.finishLoader();
                next();
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    computed: {
        ...mapState({
            rules_person: (state) => state.validation.rules_person,
            rules_update_password: (state) => state.validation.rules_update_password,
            person: (state) => state.me.person,
            entity_addresses: (state) => state.me.entity_addresses,
            entity_emails: (state) => state.me.entity_emails,
            entity_phones: (state) => state.me.entity_phones,
            active_languages: (state) => state.languages.active_languages,
        }),
        ...mapGetters(["languages"]),
    },
    methods: {
        getMe(status = true) {
            if (status) {
                this.startLoader();
            }

            this.$store
                .dispatch("fetchMe", {
                    url: "me",
                    method: "get",
                    stateProperty: "person|entity_phones|entity_addresses|entity_emails",
                    dataProperty: "person|person.entity_phones|person.entity_addresses|person.entity_emails",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        if (data.person) {
                            this.my_profile = {
                                first_name: data.person.first_name,
                                last_name: data.person.last_name,
                                nick_name: data.person.nick_name,
                                job_title: data.person.job_title,
                                unit_of_measure: data.person.unit_of_measure,
                                user_time_zone: data.person.user_time_zone,
                                theme: data.person.theme,
                                language: data.person.language,
                                entity_phones_id: data.person.entity_phones_id,
                                entity_emails_id: data.person.entity_emails_id,
                            };
                        }
                    }
                })
                .finally(() => this.finishLoader(true));
        },
        getPhones() {
            this.$store
                .dispatch("fetchMe", {
                    url: "me/phones",
                    method: "get",
                    stateProperty: "entity_phones",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        if (data.entity_phones) {
                        }
                    }
                })
                .finally(() =>
                    this.$nextTick(() => {
                        this.$store.commit("toggleModalLoader", false), this.$root.$emit("escapePressed");
                    })
                );
        },
        getEmails() {
            this.$store
                .dispatch("fetchMe", {
                    url: "me/emails",
                    method: "get",
                    stateProperty: "entity_emails",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        if (data.entity_emails) {
                        }
                    }
                })
                .finally(() =>
                    this.$nextTick(() => {
                        this.$store.commit("toggleModalLoader", false), this.$root.$emit("escapePressed");
                    })
                );
        },
        getAddresses() {
            this.$store.commit("toggleModalLoader", true);

            this.$store
                .dispatch("fetchMe", {
                    url: "me/addresses",
                    method: "get",
                    stateProperty: "entity_addresses",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        if (data.entity_addresses) {
                        }
                    }
                })
                .finally(() =>
                    this.$nextTick(() => {
                        this.$store.commit("toggleModalLoader", false), this.$root.$emit("escapePressed");
                    })
                );
        },
        getTimeZones() {
            this.$store
                .dispatch("fetchTimeZones", {
                    url: "timezones",
                    method: "get",
                    stateProperty: "time_zones",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.time_zones = data.time_zones;
                    }
                });
        },
        edit: _.debounce(
            function () {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (this.validateForm("my_profile")) {
                        this.startLoader(true);

                        this.$store
                            .dispatch("fetchMe", {
                                pk: "people_id",
                                url: "me",
                                method: "patch",
                                stateProperty: "person",
                                dataProperty: "person",
                                commit: true,
                                body: this.my_profile,
                            })
                            .then((data) => {
                                // change language to selected language
                                let language = this.languages[this.my_profile.language];
                                this.$root.$i18n.locale = language.locale;
                                this.$store.dispatch("changeLanguage", language);
                                // make changes in local storage as well
                                //TODO: updating local storage is not changing the state (ie. change unit of measure and go to maturity add form, it wont show new unit)
                                this.$store.commit("updateUser", data.person);
                                this.$store.commit("validationOff");
                                this.finishLoader();
                            });
                    }
                });
            },
            1500,
            { maxWait: 1500, leading: true, trailing: false }
        ),
        openChangePassword() {
            this.update_password_dialog = true;
        },
        changePassword: _.debounce(
            function () {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (this.validateForm("update_password")) {
                        this.$store.commit("toggleModalLoader", true);

                        this.$store
                            .dispatch("fetchMe", {
                                url: "me/password",
                                method: "patch",
                                body: this.update_password,
                            })
                            .then((data) => {})
                            .finally(() => {
                                this.$store.commit("toggleModalLoader", false);
                                this.$store.commit("validationOff");
                                this.update_password_dialog = false;
                            });
                    }
                });
            },
            1500,
            { maxWait: 1500, leading: true, trailing: false }
        ),
        getLanguages() {
            this.$store.dispatch("fetchLanguages", {
                url: "languages?status=1",
                method: "get",
                stateProperty: "active_languages",
                dataProperty: "languages",
                commit: true,
            });
        },
        showEntity(item, entity) {
            if (item && entity) {
                switch (entity) {
                    case "phone":
                        this.$refs.myPhones.showPhone(item);
                        break;
                    case "email":
                        this.$refs.myEmails.showEmail(item);
                        break;
                    case "address":
                        this.$refs.myAddresses.showAddress(item);
                        break;
                }
            }
        },
        openChangePin() {
            this.$refs.modalSupervisorPin.openDialog();
        },
    },
};
</script>
